import { useEffect, useState } from 'react';
import axios from 'axios';
import { Files } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = { at: 0, promise: null };
// Aynı ekrandaki tüm etiketler tek istekle beslenir; 30 sn sonra yenilenir
const loadLimits = () => {
  if (!cache.promise || Date.now() - cache.at > 30000) cache = { at: Date.now(), promise: axios.get(`${API}/settings/doc-page-limits`).then(r => r.data || {}).catch(() => ({})) };
  return cache.promise;
};

// Firma: Süper Admin sınır koyduysa evrak adının yanında "En fazla X sayfa"
export const PageLimitTag = ({ collection, docKey, className = '' }) => {
  const [limit, setLimit] = useState(null);
  useEffect(() => { let on = true; loadLimits().then(l => on && setLimit(l?.[collection]?.[docKey] || null)); return () => { on = false; }; }, [collection, docKey]);
  if (!limit) return null;
  return (
    <span title={`Bu evrak için en fazla ${limit} sayfalık PDF yükleyebilirsiniz. Sadece ilgili sayfaları yükleyin.`} data-testid={`page-limit-tag-${collection}-${docKey}`}
      className={`inline-flex cursor-help items-center gap-0.5 whitespace-nowrap rounded-full border border-sky-300 bg-sky-50 px-1.5 py-px text-[10px] font-semibold text-sky-700 ${className}`}>
      <Files className="h-3 w-3" />En fazla {limit} sayfa
    </span>
  );
};
